import { State } from 'app/redux';

export const getProjectsAll = (state: State) => state.projects.projects;

export const getProjects = (state: State) => getProjectsAll(state).items;

export const getSearches = (state: State) => state.projects.searches;
